import React from 'react';
import { MuiFormControl, MuiFormControlLabel, MuiRadio, MuiRadioGroup } from 'theme/material-ui';
import Typography from 'components/UI/Typography';
import Spacer from 'components/UI/Layout/Spacer';
import { FontSize } from 'modules/styles/variables';
import { StyledAsterisk } from 'components/RequiredFieldsLegend';
import { OnChangeType, OnBlurType } from 'types';

export interface Props {
  name: string;
  value: string | null;
  formLabel: string;
  onChange: OnChangeType;
  onBlur?: OnBlurType;
  required?: boolean;
}

const YesNoRadioGroup = (props: Props) => {
  const { name, value, formLabel, onChange, onBlur, required } = props;

  return (
    <MuiFormControl component="fieldset" data-testid={`yes-no-${name}-radio`}>
      <Typography fontSize={FontSize.base} data-testid={`${name}-radio-button-form-label`}>
        {formLabel}
        {required ? <StyledAsterisk /> : null}
      </Typography>
      <Spacer size="xsmall" />
      <MuiRadioGroup name={name} value={value} onChange={onChange} onBlur={onBlur}>
        <MuiFormControlLabel
          value="yes"
          control={<MuiRadio data-testid={`${name}-radio-button-yes`} color="primary" />}
          label="Yes"
        />
        <MuiFormControlLabel
          value="no"
          control={<MuiRadio color="primary" data-testid={`${name}-radio-button-no`} />}
          label="No"
        />
      </MuiRadioGroup>
    </MuiFormControl>
  );
};

export default YesNoRadioGroup;
